export const API = {
  user: {
    profile: '/v1/user/profile',
    get_promo_codes: '/v1/user/get_promo_codes',
  },
  order: {
    b2b_create: '/api/v3/private/b2b/create',
    b2b_estimate: '/api/v3/private/b2b/estimate',
  },
  promotion: (code: string) => `/api/v3/private/promotion/${code}`,
  payment: {
    payment_method_order_b2b: '/api/v3/private/payment/methods/order_b2b',
  },
  place: {
    autocomplete: '/web/v3/place/autocomplete',
    geocode_reverse: '/web/v3/place/geocode_reverse',
  },
  b2b: {
    suggest_service: '/api/v3/private/b2b/suggest_service',
  },
  public: {
    place: {
      autocomplete: '/web/v3/public/place/autocomplete',
      geocode_reverse: '/web/v3/public/place/geocode_reverse',
    },
    screen_configs: '/api/v3/public/master-data/screen-configs',
    b2b: {
      stores: '/opstech/ahasupply-api/store/list',
      stores_by_category: (categorySlug: string) =>
        `/opstech/ahasupply-api/store/category/${categorySlug}`,
      items: '/opstech/ahasupply-api/item/list',
      store_detail: '/opstech/ahasupply-api/store/detail',
      activated_categories: '/opstech/ahasupply-api/category/all',
      promo_items: '/opstech/ahasupply-api/item/promo',
      nearby_items: '/opstech/ahasupply-api/item/nearby',
      search_items: '/opstech/ahasupply-api/item/search',
      nearby_stores: '/opstech/ahasupply-api/store/nearby',
      item_detail: (itemSlug: string) =>
        `/opstech/ahasupply-api/item/detail/${itemSlug}`,
      items_by_category: (categorySlug: string) =>
        `/opstech/ahasupply-api/category/${categorySlug}`,
      tags: '/opstech/ahasupply-api/tag/all',
    },
  },
};

export const API_FETCH_TIMEOUT = 7;

export const ERROR_CODES = {
  NOT_ENOUGH_CREDIT: {
    code: 'NOT_ENOUGH_CREDIT',
    description: 'Tài khoản không đủ tiền hoặc không phải là tài khoản công nợ',
    http_code: 406,
    internal: '',
    title: 'Not enough credit',
  },

  INVALID_COD_CUSTOMER: {
    code: 'INVALID_COD_CUSTOMER',
    description:
      'Để sử dụng dịch vụ ứng tiền thu hộ, xin vui lòng liên hệ với tổng đài 1900 5454 11',
    http_code: 406,
    internal: '',
    title: 'COD is not allowed for individual customer',
  },
};
